<template>
<ProductSelectDialog
        :dialogTitle="dialogTitle"
        :centerDialogVisible="visible"
        @updateVisible="updateVisible"
        @resetPopupData="resetPopupData"
        @submitPopupData="submitPopupData"
        :popupWidth="'1200px'"
>
        <el-form :inline="true" :model="query" ref="query">
            <el-form-item  label="单品名称" prop="skuName" >
                <el-input v-model="query.skuName" placeholder="单品名称"></el-input>
            </el-form-item>
            <el-form-item  label="单品编号" prop="skuNumber" >
                <el-input v-model="query.skuNumber" placeholder="单品编号" class="handle-input mr10"></el-input>
            </el-form-item>
            <el-form-item  label="品牌" prop="agreeNumber" >
                <el-input v-model="query.agreeNumber" placeholder="品牌" class="handle-input mr10"></el-input>
            </el-form-item>
            <el-form-item  label="所属分类" prop="category" >
                <el-input v-model="query.category" placeholder="所属分类" class="handle-input mr10"></el-input>
            </el-form-item>
        </el-form>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button type="primary" icon="el-icon-delete" @click="handleClear">重置</el-button>

    <TableList
            :table-label="tableLabel"
            :loading="loading"
    >
    </TableList>

    <div class="pagination">
        <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="productTagPage.currentPage"
                :page-size="productTagPage.pageSize"
                :total="productTagPage.pageTotal"
                :small="true"
        >
        </el-pagination>
    </div>
</ProductSelectDialog>
</template>

<script>
    import ProductSelectDialog from '../../../../../components/common/epecDialog'
    import TableList from '../../../../../components/common/table-list'
    export default {
        name: "productSelectDialog",
        components: {
            ProductSelectDialog,
            TableList
        },
        props: {
            visible:{
                type:Boolean,
                required: true
            }
        },
        data() {
            return {
                dialogTitle:'选择商品',
                loading:false,
                tableLabel: [
                    { label: 'id', param: 'id',  align: 'center', type:'selection',fixed:'left'},
                    { label: '单品图片', param: 'company', align: 'center' ,slot:'company',fixed:'left'},
                    { label: '单品名称', param: 'email', align: 'center',width:'200' ,fixed:'left'},
                    { label: '单品编号', param: 'registTime', align: 'center' ,slot:'time'},
                    { label: '品牌', param: 'status', align: 'center'},
                    { label: '所属分类', param: 'registTime', align: 'center' },
                    { label: '计量单位', param: 'registTime', align: 'center' ,fixed:'right'},
                    { label: '市场价(元)', param: 'registTime', align: 'center' ,fixed:'right'},
                ],
                productTagPage: {
                    currentPage: 1,
                    pageSize: 10,
                    pageTotal: 0,
                },
                query:{
                    skuName:'',
                    skuNumber:'',
                    agreeNumber:'',
                    category:''
                }
            }
        },
        computed: {},
        created() {
        },
        methods: {
            handleSearch(){

            },
            handleClear(){

            },
            handleSizeChange(){

            },
            handleCurrentChange(){

            },
            updateVisible(){

            },
            resetPopupData(){
                this.$emit('close')
            },
            submitPopupData(){

            }
        }

    }
</script>

<style scoped>

</style>
